import React from 'react'
interface Props{
    children: React.ReactNode
}

const Mask = (props:Props) => {
  return (
        <div 
              className="mask" 
              style={{zIndex:"1101",
              backgroundColor:"rgba(0, 0, 0, 0.4)",
              position:"fixed",
              top: "0",
              left: "0",
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              pointerEvents:"auto"
              }}>
            {props.children}
        </div>
  )
}

export default Mask